import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_INVENTORY_COVERAGE_METRIC } from 'modules/reports/interfaces/IReportInventoryCoverage';

class AnalyticInventoryCoverageService extends EntityApiService<any> {
  searchAnalytic = (metric: ANALYTIC_INVENTORY_COVERAGE_METRIC, params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath(`/${metric}`), params, config));

  getLastUpdated = () => this.handleResponse(ApiClientService.get(this.getPath('/last-update')));
}

export default new AnalyticInventoryCoverageService('/ms-analytics/api/v1/inventory-coverage-analytic');
